let ProductUniqueMaps = {
  init: function () {
    
    this.setDataInWindow();
    this.getDataToMountClientMap();
    this.placeInputAutocomplete();
    this.zoomTrigger();
    this.liveInput();
    this.inputCounter();
    this.changeTextColor();
    // this.updateProductPrice();
    this.buyProduct();
    this.sizeSelect();
    this.mapPinSelect();
    this.mapColorSelect();
    this.mapFormatSelect();
    this.mapBgColorSelect();
    this.mapPinColorSelect();
    this.changeSections();
    this.changeMapColors();
    this.changeMapBgColors();
    this.changeMapFormat();
    this.addPinToMap();
    // this.hideBuyButtonOnFocus();
    this.updatePin();
    this.changePinColor();
    window.zoom = 14;
    window.latlng = '-25.465,-49.256';
    this.mountClientMap();
    this.updateInputValue();
    this.updateTextButton();
    this.updateClassFocus();
    this.updateFocusElement();
    this.focusFirstTabInput();
  },

  changeSections: function () {
    const headerButtons = document.querySelectorAll(".product-right-header__button");
    const productSections = document.querySelectorAll(".product-right-section");

    for (const headerButtonsHandle of headerButtons) {
      headerButtonsHandle.addEventListener("click", function (e) {
        for (const productSectionsHandle of productSections) {
          if (e.target.id === productSectionsHandle.id) {
            if (e.target.classList.contains("button-active")) return;

            for (const buttonHandleRemove of headerButtons) {
              buttonHandleRemove.classList.add("button-disabled");
              buttonHandleRemove.classList.remove("button-active");
            }
            for (const sectionsHandleRemove of productSections) {
              sectionsHandleRemove.classList.add("section-hide");
              sectionsHandleRemove.classList.remove("section-active");
            }

            e.target.classList.remove("button-disabled");
            e.target.classList.add("button-active");

            productSectionsHandle.classList.remove("section-hide");
            productSectionsHandle.classList.add("section-active");
          }
        }
        ProductUniqueMaps.updateTextButton();
        setTimeout(() => {
          ProductUniqueMaps.focusFirstTabInput();
        }, 100)
      })
    }
  },

  focusFirstTabInput: function() {
    document.querySelector('.-focus')?.classList.remove('.-focus');
    const tabActiveId = document.querySelector('.product-right-header__button.button-active').getAttribute('id');
    const sectionElementActive = document.querySelector(`#${tabActiveId}.product-right-section [tabindex]`);
    console.log(sectionElementActive);
    sectionElementActive.focus();
  },

  mapColorSelect: function () {
    const mapColors = document.querySelectorAll(".product-right-design__map-color");

    for (const mapColorsHandle of mapColors) {
      mapColorsHandle.addEventListener("click", function () {
        if (this.classList.contains("map-color-selected")) return;

        for (const mapColorsHandleRemove of mapColors) {
          mapColorsHandleRemove.classList.remove("map-color-selected");
        }

        this.classList.add("map-color-selected");
      })
    }
  },

  mapPinSelect: function () {
    const mapColors = document.querySelectorAll(".product-right-section__pin-div");

    for (const mapColorsHandle of mapColors) {
      mapColorsHandle.addEventListener("click", function () {
        if (this.classList.contains("pin-selected")) return;

        for (const mapColorsHandleRemove of mapColors) {
          mapColorsHandleRemove.classList.remove("pin-selected");
        }

        this.classList.add("pin-selected");
      })
    }
  },

  mapPinColorSelect: function () {
    const mapColors = document.querySelectorAll(".product-right-section__pin-color");

    for (const mapColorsHandle of mapColors) {
      mapColorsHandle.addEventListener("click", function () {
        if (this.classList.contains("pin-color-selected")) return;

        for (const mapColorsHandleRemove of mapColors) {
          mapColorsHandleRemove.classList.remove("pin-color-selected");
        }

        this.classList.add("pin-color-selected");

      })
    }
  },

  mapFormatSelect: function () {
    const mapFormat = document.querySelectorAll(".product-right-design__map-format");

    for (const mapFormatHandle of mapFormat) {
      mapFormatHandle.addEventListener("click", function () {
        if (this.classList.contains("map-format-selected")) return;

        for (const mapFormatHandleRemove of mapFormat) {
          mapFormatHandleRemove.classList.remove("map-format-selected");
        }

        this.classList.add("map-format-selected");

      })
    }
  },

  mapBgColorSelect: function () {
    const mapColors = document.querySelectorAll(".product-right-design__map-bg-color");

    for (const mapColorsHandle of mapColors) {
      mapColorsHandle.addEventListener("click", function () {
        if (this.classList.contains("map-bg-color-selected")) return;

        for (const mapColorsHandleRemove of mapColors) {
          mapColorsHandleRemove.classList.remove("map-bg-color-selected");
        }

        this.classList.add("map-bg-color-selected");

      })
    }
  },

  changeMapBgColors: function () {
    const map = document.querySelector(".product-left__main");
    const mapBgColors = document.querySelectorAll(".product-right-design__map-bg-color");

    for(const mapBgColorsHandle of mapBgColors){
      mapBgColorsHandle.addEventListener("click", function(){
        map.style.backgroundColor = this.dataset.mapBgColor

      })
    }    
  },

  sizeSelect: function () {
    const sizes = document.querySelectorAll(".product-right-design__size");

    for (const sizesHandle of sizes) {
      sizesHandle.addEventListener("click", function () {
        if (this.classList.contains("size-selected")) return;

        for (const sizesHandle of sizes) {
          sizesHandle.classList.remove("size-selected");
        }

        this.classList.add("size-selected");
      })
    }
  },

  liveInput: function(){
    const squareSelected = document.querySelector('.map-format-selected[data-map-format="square-directions"]');
    const textInputMessage = document.querySelector(".product-right-section__first-message");
    const textInputLocal = document.querySelector(".product-right-section__local-message");
    const textInputComplement = document.querySelector(".product-right-section__complement-message");

    const textAreaMessage = document.querySelector(".product-left__text-message");
    const textAreaLocal = document.querySelector(".product-left__text-local");
    const textAreaComplement = document.querySelector(".product-left__text-complement");

    textInputMessage.addEventListener("keyup", function(){
      textAreaMessage.textContent = this.value;
      
      if(this.value.length > 24){
        textAreaMessage.classList.add("word-break");
      } else{
        textAreaMessage.classList.remove("word-break");
      }
      if (this.value.length < 22) {
        textAreaMessage.classList.remove("font-m");
        textAreaMessage.classList.remove("font-p");
        textAreaMessage.classList.add("font-g");
      } else if (this.value.length >= 22 && this.value.length < 44) {
        textAreaMessage.classList.remove("font-g");
        textAreaMessage.classList.remove("font-p");
        textAreaMessage.classList.add("font-m");
      } 
      // else if (this.value.length >= 44 && squareSelected) {
      //   textAreaMessage.classList.remove("font-g");
      //   textAreaMessage.classList.remove("font-m");
      //   textAreaMessage.classList.add("font-p");
      // }
    });

    textInputLocal.addEventListener("keyup", function(){
        if (this.value.length > 13 && this.value.length < 20) {
            textAreaLocal.classList.remove('text-local-p');
            textAreaLocal.classList.add('text-local-m');
        } else if(this.value.length >= 20) {
            textAreaLocal.classList.remove('text-local-m');
            textAreaLocal.classList.add('text-local-p');
        } else {
            textAreaLocal.classList.remove('text-local-m');
            textAreaLocal.classList.remove('text-local-p');
        }
      textAreaLocal.textContent = this.value;
    });

    textInputComplement.addEventListener("keyup", function(){
      if(this.value.length >= 24) {
        document.querySelector('.product-left__text-complement').classList.add('fs-m')
      } else {
        document.querySelector('.product-left__text-complement').classList.remove('fs-m')
      }
      textAreaComplement.textContent = this.value;
    });
  },

  inputCounter: function(){
    const textInputMessage = document.querySelector(".product-right-section__first-message");
    const textInputLocal = document.querySelector(".product-right-section__local-message");
    const textInputComplement = document.querySelector(".product-right-section__complement-message");
    const messageCounter = document.querySelector(".product-right-section__counter-1");
    const localCounter = document.querySelector(".product-right-section__counter-2");
    const complementCounter = document.querySelector(".product-right-section__counter-3");

    textInputMessage.addEventListener("keyup", function(){
      messageCounter.textContent = 66 - this.value.length;
    });

    textInputLocal.addEventListener("keyup", function(){
      localCounter.textContent = 25 - this.value.length;
    });

    textInputComplement.addEventListener("keyup", function(){
      complementCounter.textContent = 30 - this.value.length;
    });
  },

  zoomTrigger: function(){
    const zoomIn = document.querySelector('.zoom-in');
    const zoomOut = document.querySelector('.zoom-out');
    

    zoomIn.addEventListener('click', () => {
        window.zoom = window.zoom + 1;
        this.mountClientMap();
        
    })

    zoomOut.addEventListener('click', () => {
        window.zoom = window.zoom - 1;
        this.mountClientMap();
    })
  },

  changeTextColor: function(){
    const bgColor = document.querySelectorAll(".product-right-design__map-bg-color");
    const textAreaMessage = document.querySelector(".product-left__text-message");
    const textAreaLocal = document.querySelector(".product-left__text-local");
    const textAreaComplement = document.querySelector(".product-left__text-complement");

    for(const bgColorHandle of bgColor){
      bgColorHandle.addEventListener("click", function(){
        if(this.dataset.mapBgColor === "#fff"){
          textAreaMessage.style.color = "#000";
          textAreaLocal.style.color = "#000";
          textAreaComplement.style.color = "#000";
        } else{
          textAreaMessage.style.color = "#fff";
          textAreaLocal.style.color = "#fff";
          textAreaComplement.style.color = "#fff";
        }
      });
    } 
  },

  changeMapFormat: function(){
    var map = document.querySelector("#map");
    var mapFormats = document.querySelectorAll(".product-right-design__map-format");
    var colors = document.querySelectorAll(".product-right-design__map-bg-color");

    for(var mapFormatsHandle of mapFormats){
      mapFormatsHandle.addEventListener("click", function(){
          document.querySelector('.product-left__main').classList.remove('-square-directions');
        document.querySelector('.product-right-section__first-message').style.display = 'block';
        document.querySelector('.product-right-section__message-row').style.display = 'block';
        var colorSelected = document.querySelector(".map-bg-color-selected").dataset.mapFormatColor;
        document.querySelector(".product-left__main").dataset.format = `-${this.dataset.mapFormat}`;
        if(this.dataset.mapFormat === "circle"){
          map.style.borderRadius = '50%'
          $(".image-mask-maps").remove(); 
          $(".product-left__main").append(`<img class="image-mask-maps circle-maps" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/circle-${colorSelected}.png"/>`)
        } else if(this.dataset.mapFormat === "heart"){
            map.style.borderRadius = '50%'
          $(".image-mask-maps").remove();
          $(".product-left__main").append(`<img class="image-mask-maps heart-maps" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/heart-${colorSelected}.png"/>`)
        } else if(this.dataset.mapFormat === "square"){
            map.style.borderRadius = '0%'
          $(".image-mask-maps").remove();        
            // $(".product-left__main").append(`<img class="image-mask-maps circle-square" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/square-${colorSelected}.png"/>`)
        } else if(this.dataset.mapFormat === "square-directions"){
            map.style.borderRadius = '0%'
            document.querySelector('.product-left__main').classList.add('-square-directions');
            // document.querySelector('.product-left__text-message').innerText = '';
            // document.querySelector('.product-right-section__first-message').value = '';
            // document.querySelector('.product-right-section__first-message').style.display = 'none';
            // document.querySelector('.product-right-section__message-row').style.display = 'none';
            $(".image-mask-maps").remove();
            $(".product-left__main").append(`<img class="image-mask-maps square-directions" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/square-directions-${colorSelected}.png?v=1.3"/>`)
        }
      })
    }

    for(var colorsHandle of colors){
        colorsHandle.addEventListener("click", function(){
            if(formatSelected === "square") return;
            
            var formatSelected = document.querySelector(".map-format-selected").dataset.mapFormat;
            var colorSelected = this.dataset.mapFormatColor

            if(formatSelected === 'square-directions') {
                map.style.borderRadius = '0%'
                document.querySelector('.product-left__main').classList.add('-square-directions');
                // document.querySelector('.product-left__text-message').innerText = '';
                // document.querySelector('.product-right-section__first-message').value = '';
                // document.querySelector('.product-right-section__first-message').style.display = 'none';
                // document.querySelector('.product-right-section__message-row').style.display = 'none';
                $(".image-mask-maps").remove();
                $(".product-left__main").append(`<img class="image-mask-maps square-directions" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/square-directions-${colorSelected}.png?v=1.0"/>`)
            } else {
                document.querySelector('.product-left__main').classList.remove('-square-directions');
                document.querySelector('.product-right-section__first-message').style.display = 'block';
                document.querySelector('.product-right-section__message-row').style.display = 'block';
                $(".image-mask-maps").remove();
                $(".product-left__main").append(`<img class="image-mask-maps ${formatSelected}-maps" src="https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/${formatSelected}-${colorSelected}.png"/>`)
            }
        })
    }

  },

    updateProductPrice: function () { 
      // const productSizes = document.querySelectorAll('.product-right-design__size');
      // let a2Promo = skuJson_0.skus[0].listPriceFormated !== skuJson_0.skus[0].bestPriceFormated;
      // let a3Promo = skuJson_0.skus[1].listPriceFormated !== skuJson_0.skus[1].bestPriceFormated;
      // let a4Promo = skuJson_0.skus[2].listPriceFormated !== skuJson_0.skus[2].bestPriceFormated;

      skuJson_0.skus.forEach(skuItem => {
        let skuSize = skuItem.skuname.toLocaleLowerCase();
        let currentProductSizeElement = document.querySelector(`[data-size="${skuSize}"]`);
        let skuPricePromo = skuItem.listPriceFormated !== skuItem.bestPriceFormated;
        console.log(skuItem);
        console.log(skuItem.available);

        if(skuItem.available) {
          currentProductSizeElement.querySelector('.product-right-design__size-price').innerHTML = `${skuPricePromo ? '<small>' + skuItem.listPriceFormated + '</small>' : ''}${skuItem.bestPriceFormated}`;
        } else {
          currentProductSizeElement.querySelector('.product-right-design__size-price').innerHTML = `Esgotado`;
          currentProductSizeElement.classList.add('disabled');
        }
      })

      if (document.querySelector('.size-selected').classList.contains('disabled')) {
        document.querySelector('.size-selected').classList.remove('size-selected');
        document.querySelector('.product-right-design__size-wrapper .product-right-design__size:not(.disabled)').classList.add('size-selected');
      }
      
       

      // if (skuJson_0.skus[2].available) {
      //   productSizes[0].querySelector('.product-right-design__size-price').innerHTML = `${a4Promo ? '<small>' + skuJson_0.skus[2].listPriceFormated + '</small>' : ''}${skuJson_0.skus[2].bestPriceFormated}`;
      // } else {
      //   productSizes[0].querySelector('.product-right-design__size-price').innerHTML = `Esgotado`;
      //   productSizes[0].querySelector('.product-right-design__size-price').parentNode.classList.add('disabled');
      // }

      // if (skuJson_0.skus[1].available) {
      //   productSizes[1].querySelector('.product-right-design__size-price').innerHTML = `${a3Promo ? '<small>' + skuJson_0.skus[1].listPriceFormated + '</small>' : ''}${skuJson_0.skus[1].bestPriceFormated}`;
      // } else {
      //   productSizes[1].querySelector('.product-right-design__size-price').innerHTML = `Esgotado`;
      //   productSizes[1].querySelector('.product-right-design__size-price').parentNode.classList.add('disabled');
      // }

      // if (skuJson_0.skus[0].available) {
      //   productSizes[2].querySelector('.product-right-design__size-price').innerHTML = `${a2Promo ? '<small>' + skuJson_0.skus[0].listPriceFormated + '</small>' : ''}${skuJson_0.skus[0].bestPriceFormated}`;
      // } else {
      //   productSizes[2].querySelector('.product-right-design__size-price').innerHTML = `Esgotado`;
      //   productSizes[2].querySelector('.product-right-design__size-price').parentNode.classList.add('disabled');
      // }
        
    },

  updateFocusElement: function() {
    const focusElement = document.querySelector('.-focus');
    if (focusElement) {
      const focusIndex = focusElement?.tabIndex + 1;
      document.querySelector(`[tabindex="${focusIndex}"]`).focus();

    } else{
      document.querySelector(`[tabindex="1"]`).focus();
    }
  },

  buyProduct: function () {
    const mqMax = window.matchMedia("(max-width: 1023px)").matches;
    const buyButton = document.querySelector(".product-right__button");

    buyButton.addEventListener("click", function () {
      const size = document.querySelector(".size-selected").dataset.size;
        let stepOneActive = document.querySelector('#sec-1.button-active');
        let stepTwoActive = document.querySelector('#sec-2.button-active');

        if (stepOneActive) {
          if(mqMax) {
            if(document.querySelector('.-focus')?.dataset.last) {
              document.querySelector('#sec-2').click()
            }
            ProductUniqueMaps.updateFocusElement();
            ProductUniqueMaps.updateTextButton();
            return;
          } else {
            document.querySelector('#sec-2').click()
            return;
          }
        }

        if (stepTwoActive) {
          if (mqMax) {
            if (document.querySelector('.-focus')?.dataset.last) {
              document.querySelector('#sec-3').click()
            }
            ProductUniqueMaps.updateFocusElement();
            ProductUniqueMaps.updateTextButton();
            return;
          } else {
            document.querySelector('#sec-3').click()
            return;
          }
        }

      if (size === 'a2') {
        ProductUniqueMaps.addProductAndGoToCheckout(261) //alterar o parametro para o sku correto
      } else if (size === 'a3') {
        ProductUniqueMaps.addProductAndGoToCheckout(262)
      } else if (size === 'a4') {
        ProductUniqueMaps.addProductAndGoToCheckout(263)
      }
    })
  },

  addProductAndGoToCheckout: function (sku) {
    let item = {
      id: sku,
      quantity: 1, 
      seller: '1'
    };

    let addedItemId = item.id;

    vtexjs.checkout.addToCart([item], null, 1)
      .done(orderForm => {

        var itemIndex = orderForm.items.length - 1;
        var attachmentName = "UniqueMaps";

        var message = document.querySelector('.product-right-section__first-message').value;
        var locationMessage = document.querySelector('.product-right-section__local-message').value;
        var locationComp = document.querySelector('.product-right-section__complement-message').value;
        var pinSelected = document.querySelector('.product-right-section__pin-row .pin-selected').dataset.pin;
        var pinColorSelected = document.querySelector('.product-right-section__pin-color-row .pin-color-selected').dataset.pinColor;
        var pinColorValue = (pinSelected !== 'no-pin' ? pinColorSelected : '');
        var mapColor = document.querySelector('.product-right-design__map-color.map-color-selected').dataset.mapColor;
        var bgColor = document.querySelector('.product-right-design__map-bg-color.map-bg-color-selected').dataset.mapBgColor;
        var format = document.querySelector('.product-right-design__map-format.map-format-selected').dataset.mapFormat;


        let content = {
            local: locationMessage || '',
            pin: pinSelected || '',
            cor_do_pin: pinColorValue || '',
            primeira_mensagem: message || '',
            local_texto: locationMessage || '',
            complemento: locationComp || '',
            cor_do_mapa: mapColor || '',
            cor_do_fundo: bgColor || '',
            formato: format || '',
            latitude: '',
            longitude: '',
            map: `${window.mapImageUrl}`, 
        };

        console.log(orderForm);
        console.log(itemIndex);
        console.log(attachmentName)
        console.log(content);
        for (let index = 0; index < orderForm.items.length; index++) {
          const element = orderForm.items[index];
          if (element.id == addedItemId && !element.attachments.length) {
            var itemIndex = index;
            vtexjs.checkout.addItemAttachment(itemIndex, attachmentName, content, null, false)
                .done(function (orderForm) {
                    window.location.href = '/checkout/#/cart'
                });
          }
        }

      });
  },

  setDataInWindow: function () {
    const map1Styles = `&style=feature:all|element:geometry|visibility:off&style=feature:administrative|element:labels.text.fill|color:0x444444&style=feature:administrative.province|element:labels.text|visibility:off&style=feature:administrative.province|element:labels.text.stroke|visibility:off&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.neighborhood|element:labels.text|visibility:off&style=feature:administrative.land_parcel|element:labels.text|visibility:off&style=feature:administrative.land_parcel|element:labels.text.fill|visibility:off&style=feature:landscape|element:all|color:0x444444|visibility:on|lightness:-70|weight:0.2&style=feature:landscape|element:geometry.fill|visibility:on|color:0xfbd09d&style=feature:landscape.natural.landcover|element:geometry|visibility:on&style=feature:landscape.natural.landcover|element:geometry.fill|visibility:on&style=feature:landscape.natural.landcover|element:geometry.stroke|visibility:on&style=feature:landscape.natural.landcover|element:labels.text|visibility:off&style=feature:landscape.natural.terrain|element:geometry.fill|color:0xff0000|visibility:off&style=feature:poi|element:all|visibility:off&style=feature:road|element:all|saturation:-100|lightness:45&style=feature:road|element:labels.text.fill|lightness:-75&style=feature:road|element:labels.text.stroke|visibility:off&style=feature:road.highway|element:all|visibility:simplified&style=feature:road.highway|element:geometry.fill|visibility:on|color:0xf7931e|weight:1.02&style=feature:road.highway|element:geometry.stroke|visibility:off|weight:0.31&style=feature:road.highway|element:labels.text|visibility:on&style=feature:road.highway|element:labels.text.fill|visibility:on&style=feature:road.highway|element:labels.text.stroke|visibility:off|color:0xf7931e|weight:2.29&style=feature:road.arterial|element:all|visibility:on&style=feature:road.arterial|element:geometry.fill|visibility:on|lightness:-3|weight:1.00&style=feature:road.arterial|element:geometry.stroke|visibility:off|weight:1.25&style=feature:road.arterial|element:labels.icon|visibility:off&style=feature:road.local|element:geometry.stroke|weight:0.51|hue:0xff0000&style=feature:transit|element:all|visibility:off&style=feature:water|element:all|color:0x81cfce|visibility:on&style=feature:water|element:geometry|visibility:on|color:0xff0000&style=feature:water|element:geometry.fill|color:0x4cc2c1|lightness:13&style=feature:water|element:labels.text|visibility:off&style=feature:water|element:labels.text.fill|color:0x020000|visibility:off&style=feature:water|element:labels.text.stroke|visibility:off`;
    const map2Styles = `&style=feature:all|element:all|visibility:on&style=feature:all|element:geometry|color:0x4d1111|visibility:on&style=feature:administrative|element:all|visibility:off&style=feature:administrative|element:geometry|visibility:off&style=feature:administrative|element:labels|visibility:off&style=feature:administrative.country|element:geometry|visibility:on|color:0x99d7e3|weight:1.00&style=feature:administrative.country|element:geometry.stroke|color:0x99d7e3&style=feature:administrative.province|element:geometry.stroke|color:0xffffff&style=feature:administrative.locality|element:all|visibility:off&style=feature:administrative.locality|element:geometry|visibility:on&style=feature:administrative.locality|element:geometry.fill|visibility:on&style=feature:administrative.locality|element:geometry.stroke|visibility:on&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.locality|element:labels.icon|visibility:off&style=feature:administrative.neighborhood|element:all|visibility:off&style=feature:administrative.neighborhood|element:geometry|visibility:off&style=feature:landscape|element:all|visibility:off&style=feature:landscape|element:geometry|visibility:on|color:0x000000&style=feature:landscape|element:labels|visibility:off&style=feature:landscape.man_made|element:all|visibility:off&style=feature:landscape.man_made|element:labels|visibility:off&style=feature:landscape.natural.landcover|element:all|visibility:off|color:0x080000&style=feature:landscape.natural.landcover|element:labels|visibility:off&style=feature:poi|element:all|visibility:off&style=feature:poi|element:labels|visibility:off&style=feature:road|element:geometry|visibility:on|color:0x99d7e3&style=feature:road|element:labels|visibility:off&style=feature:road.highway|element:geometry.fill|weight:0.80&style=feature:road.arterial|element:geometry.fill|weight:0.90&style=feature:road.local|element:geometry.fill|weight:0.31&style=feature:transit|element:all|visibility:off&style=feature:transit|element:geometry|visibility:on|color:0x99d7e3&style=feature:transit|element:labels|visibility:off&style=feature:transit.station|element:all|visibility:off&style=feature:water|element:all|visibility:on|color:0xffffff|saturation:0&style=feature:water|element:geometry|visibility:on|color:0x99d7e3&style=feature:water|element:labels|visibility:off`;
    const map3Styles = `&style=feature:administrative|element:labels.text.fill|color:0x444444&style=feature:administrative.country|element:geometry.stroke|visibility:on|color:0xffd200|weight:1.05&style=feature:administrative.country|element:labels.text|visibility:off&style=feature:administrative.country|element:labels.text.stroke|visibility:simplified&style=feature:administrative.province|element:labels.text|visibility:off&style=feature:administrative.locality|element:labels.text|visibility:off|color:0x878484&style=feature:administrative.neighborhood|element:labels.text|visibility:off&style=feature:administrative.land_parcel|element:labels.text|visibility:off&style=feature:landscape|element:all|color:0xf2f2f2&style=feature:landscape.man_made|element:geometry.fill|visibility:off|color:0xffe6e6&style=feature:poi|element:all|visibility:off&style=feature:poi|element:geometry|visibility:off&style=feature:poi|element:labels|visibility:off&style=feature:road|element:all|saturation:-100|lightness:45|visibility:off&style=feature:road|element:geometry|visibility:off|color:0xffd200&style=feature:road|element:labels.icon|visibility:off&style=feature:road.highway|element:all|visibility:simplified&style=feature:road.highway|element:geometry.fill|color:0xffc800&style=feature:road.highway|element:labels.text|visibility:on|color:0x8bf200&style=feature:road.highway|element:labels.text.fill|color:0xffffff|visibility:off&style=feature:road.highway|element:labels.text.stroke|color:0xffffff|visibility:simplified&style=feature:road.highway|element:labels.icon|visibility:off&style=feature:road.highway.controlled_access|element:labels.text|visibility:off&style=feature:road.highway.controlled_access|element:labels.icon|visibility:off&style=feature:road.arterial|element:geometry.fill|visibility:on|color:0xffc900&style=feature:road.arterial|element:labels.text|visibility:off&style=feature:road.arterial|element:labels.icon|visibility:off&style=feature:road.local|element:geometry.fill|visibility:on|color:0xffb600&style=feature:road.local|element:labels.text|visibility:off&style=feature:road.local|element:labels.icon|visibility:off&style=feature:transit|element:all|visibility:off&style=feature:water|element:all|color:0xf5a301|visibility:on&style=feature:water|element:labels.text.fill|color:0x000000&style=feature:water|element:labels.text.stroke|visibility:off`;
    const map4Styles = `&style=feature:all|element:all|visibility:off&style=feature:road|element:geometry|visibility:on|color:0x131313&style=feature:road.highway|element:geometry|visibility:simplified&style=feature:road.highway.controlled_access|element:geometry|visibility:simplified&style=feature:road.arterial|element:geometry|visibility:simplified&style=feature:road.local|element:geometry|visibility:simplified&style=feature:water|element:all|visibility:on|lightness:-100&style=feature:water|element:geometry.fill|visibility:on|color:0x262626&style=feature:landscape|element:geometry|color:0xffffff|visibility:on&style=feature:water|element:labels.text|visibility:simplified`;
    const map5Styles = `&style=feature:all|element:labels.text.fill|color:0xffffff&style=feature:all|element:labels.text.stroke|color:0x74001b|lightness:-8&style=feature:administrative|element:geometry|color:0xffa300|weight:0.4|visibility:on&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.locality|element:labels.icon|visibility:off&style=feature:administrative.neighborhood|element:labels.text|visibility:simplified&style=feature:administrative.neighborhood|element:labels.icon|visibility:off&style=feature:administrative.land_parcel|element:labels.text|visibility:off&style=feature:administrative.land_parcel|element:labels.icon|visibility:off&style=feature:landscape|element:geometry|color:0xb52127|visibility:on&style=feature:landscape|element:labels.text|visibility:off&style=feature:poi|element:geometry|color:0xc5531b|visibility:on&style=feature:poi.attraction|element:labels.icon|visibility:off&style=feature:poi.business|element:labels.icon|visibility:off&style=feature:poi.government|element:labels.icon|visibility:off&style=feature:poi.medical|element:labels.icon|visibility:off&style=feature:poi.park|element:labels.icon|visibility:off&style=feature:poi.place_of_worship|element:labels.icon|visibility:off&style=feature:poi.school|element:labels.icon|visibility:off&style=feature:poi.sports_complex|element:labels.icon|visibility:off&style=feature:road.highway|element:geometry.fill|color:0x74001b|lightness:-10&style=feature:road.highway|element:geometry.stroke|color:0xda3c3c&style=feature:road.highway|element:labels.text|visibility:simplified|color:0xfba8a8&style=feature:road.highway|element:labels.icon|visibility:off&style=feature:road.highway.controlled_access|element:labels.icon|visibility:off&style=feature:road.arterial|element:geometry.fill|color:0x74001b&style=feature:road.arterial|element:geometry.stroke|color:0xda3c3c&style=feature:road.arterial|element:labels.text|visibility:off|color:0xff8181&style=feature:road.arterial|element:labels.icon|visibility:off&style=feature:road.local|element:geometry.fill|color:0x990c19&style=feature:road.local|element:geometry.stroke|visibility:off&style=feature:road.local|element:labels.text|visibility:off&style=feature:road.local|element:labels.icon|visibility:off&style=feature:transit|element:geometry|color:0x6a0d10|visibility:on&style=feature:transit|element:labels.text|visibility:off&style=feature:transit|element:labels.icon|visibility:off&style=feature:water|element:geometry|color:0xffdfa6`;
    const map6Styles = `&style=feature:administrative.country|element:geometry.stroke|lightness:-5|color:0xb0b0b0|weight:1.7|visibility:off&style=feature:administrative.country|element:labels.text|visibility:off&style=feature:administrative.province|element:all|visibility:off&style=feature:administrative.province|element:labels.text|visibility:off&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.neighborhood|element:labels.text|visibility:off&style=feature:administrative.land_parcel|element:labels.text|visibility:off&style=feature:landscape|element:geometry|color:0xFFB3B3|lightness:26&style=feature:landscape.man_made|element:labels.text|visibility:off&style=feature:landscape.natural|element:labels.text|visibility:off&style=feature:landscape.natural.landcover|element:geometry|visibility:off&style=feature:landscape.natural.landcover|element:labels.text|visibility:off&style=feature:landscape.natural.landcover|element:labels.icon|visibility:off&style=feature:landscape.natural.terrain|element:labels.text|visibility:off&style=feature:landscape.natural.terrain|element:labels.icon|visibility:off&style=feature:poi|element:geometry|color:0xFFB3B3&style=feature:poi.attraction|element:labels.icon|visibility:off&style=feature:poi.business|element:labels.icon|visibility:off&style=feature:poi.government|element:labels.icon|visibility:off&style=feature:poi.medical|element:labels.text|visibility:off&style=feature:poi.medical|element:labels.icon|visibility:off&style=feature:poi.park|element:labels.text|visibility:off&style=feature:poi.park|element:labels.icon|visibility:off&style=feature:poi.place_of_worship|element:labels.icon|visibility:off&style=feature:poi.school|element:labels.icon|visibility:off&style=feature:poi.sports_complex|element:labels.icon|visibility:off&style=feature:road.highway|element:all|color:0xFFB3B3&style=feature:road.highway|element:labels.text|visibility:off&style=feature:road.highway|element:labels.icon|visibility:off&style=feature:road.arterial|element:all|visibility:off&style=feature:road.arterial|element:labels.icon|visibility:off&style=feature:road.local|element:all|visibility:off&style=feature:road.local|element:geometry.fill|visibility:on&style=feature:road.local|element:labels.icon|visibility:off&style=feature:transit|element:all|visibility:off&style=feature:transit|element:geometry.fill|visibility:on|color:0xd89e9e&style=feature:transit|element:labels.icon|visibility:off&style=feature:transit.line|element:labels.icon|visibility:off&style=feature:water|element:geometry|color:0xFFB3B3|lightness:66&style=feature:water|element:labels.text|visibility:on|color:0xce8c8c|weight:1.20`;
    const map7Styles = `&style=feature:administrative.country|element:labels.text|visibility:simplified&style=feature:administrative.province|element:labels.text|visibility:off&style=feature:administrative.locality|element:all|hue:0x2c2e33|saturation:7|lightness:19|visibility:on&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.neighborhood|element:labels.text|visibility:off&style=feature:administrative.land_parcel|element:labels.text|visibility:off&style=feature:landscape|element:all|hue:0xffffff|saturation:-100|lightness:100|visibility:simplified&style=feature:landscape.man_made|element:labels.icon|visibility:off&style=feature:landscape.natural.terrain|element:labels.icon|visibility:off&style=feature:poi|element:all|hue:0xffffff|saturation:-100|lightness:100|visibility:off&style=feature:poi|element:labels.icon|visibility:off&style=feature:poi.attraction|element:labels.icon|visibility:off&style=feature:poi.business|element:labels.icon|visibility:off&style=feature:poi.government|element:labels.icon|visibility:off&style=feature:poi.medical|element:labels.icon|visibility:off&style=feature:poi.park|element:labels.icon|visibility:off&style=feature:poi.place_of_worship|element:labels.icon|visibility:off&style=feature:poi.school|element:labels.icon|visibility:off&style=feature:poi.sports_complex|element:labels.icon|visibility:off&style=feature:road|element:geometry|hue:0x00ff96|saturation:-100|lightness:-30|visibility:simplified|gamma:1.14&style=feature:road|element:labels|hue:0x008eff|saturation:-93|lightness:31|visibility:off&style=feature:road|element:labels.icon|visibility:off&style=feature:road.highway|element:labels.icon|visibility:off&style=feature:road.highway.controlled_access|element:labels.icon|visibility:off&style=feature:road.arterial|element:labels|hue:0x008eff|saturation:-93|lightness:-2|visibility:off&style=feature:road.local|element:geometry|hue:0xe9ebed|saturation:-90|lightness:-8|visibility:simplified&style=feature:road.local|element:labels.icon|visibility:off&style=feature:transit|element:all|hue:0xe9ebed|saturation:10|lightness:69|visibility:on&style=feature:transit|element:labels.icon|visibility:off&style=feature:transit.line|element:labels.icon|visibility:off&style=feature:transit.station|element:labels.icon|visibility:off&style=feature:water|element:all|hue:0xe9ebed|saturation:-78|lightness:67|visibility:simplified`;
    const map8Styles = `&style=feature:all|element:labels.text.fill|visibility:on|color:0xffffff&style=feature:all|element:labels.text.stroke|color:0xffffff|visibility:on|weight:0.9&style=feature:all|element:labels.icon|visibility:off&style=feature:administrative|element:geometry|color:0x1f8a70|weight:0.7|visibility:off&style=feature:administrative.country|element:labels.text|visibility:off&style=feature:administrative.province|element:labels.text|visibility:off&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.neighborhood|element:labels.text|visibility:off&style=feature:administrative.neighborhood|element:labels.text.fill|visibility:off&style=feature:administrative.neighborhood|element:labels.text.stroke|visibility:off&style=feature:administrative.neighborhood|element:labels.icon|visibility:off&style=feature:administrative.land_parcel|element:labels.text|visibility:off&style=feature:landscape|element:geometry|color:0x1f8a70|visibility:on&style=feature:poi|element:geometry|color:0x1f8a70|visibility:off&style=feature:poi|element:labels|visibility:off&style=feature:road.highway|element:geometry|color:0xfd7400&style=feature:road.highway|element:labels.text|visibility:off&style=feature:road.arterial|element:geometry|lightness:-44|color:0x1f8a70|saturation:100|gamma:1.04&style=feature:road.arterial|element:labels.text|visibility:off&style=feature:road.local|element:geometry|color:0x1f8a70|lightness:-17&style=feature:road.local|element:labels.text|visibility:off&style=feature:transit|element:geometry|color:0x1f8a70|lightness:-10&style=feature:water|element:geometry|color:0x004358`;
    const map9Styles = `&style=feature:all|element:labels.text.fill|saturation:36|color:0x000000|lightness:40&style=feature:all|element:labels.text.stroke|visibility:on|color:0x000000|lightness:16&style=feature:all|element:labels.icon|visibility:off&style=feature:administrative|element:geometry.fill|lightness:20&style=feature:administrative|element:geometry.stroke|color:0x000000|lightness:17|weight:1.2&style=feature:administrative.province|element:labels.text|visibility:off&style=feature:administrative.province|element:labels.text.fill|color:0xe3b141&style=feature:administrative.locality|element:labels.text|visibility:off&style=feature:administrative.locality|element:labels.text.fill|color:0xe0a64b&style=feature:administrative.locality|element:labels.text.stroke|color:0x0e0d0a&style=feature:administrative.neighborhood|element:labels.text.fill|color:0xd1b995&style=feature:landscape|element:geometry|color:0x000000|lightness:20&style=feature:poi|element:geometry|color:0x000000|lightness:21&style=feature:road|element:labels.text.stroke|color:0x12120f&style=feature:road.highway|element:geometry.fill|lightness:-77|gamma:4.48|saturation:24|weight:0.65&style=feature:road.highway|element:geometry.stroke|lightness:29|weight:0.2&style=feature:road.highway|element:labels.text|visibility:off&style=feature:road.highway.controlled_access|element:geometry.fill|color:0xf6b044|visibility:off&style=feature:road.arterial|element:geometry|color:0x4f4e49|weight:0.36&style=feature:road.arterial|element:labels.text|visibility:simplified&style=feature:road.arterial|element:labels.text.fill|color:0xc4ac87&style=feature:road.arterial|element:labels.text.stroke|color:0x262307&style=feature:road.local|element:geometry|color:0xa4875a|lightness:16|weight:0.16&style=feature:road.local|element:labels.text|visibility:off&style=feature:road.local|element:labels.text.fill|color:0xdeb483&style=feature:transit|element:geometry|color:0x000000|lightness:19&style=feature:transit.line|element:labels.text|visibility:off&style=feature:water|element:geometry|color:0x0f252e|lightness:17&style=feature:water|element:geometry.fill|color:0x080808|gamma:3.14|weight:1.07`;
    const map10Styles = `&style=feature:all|element:labels|visibility:off&style=feature:all|element:labels.icon|visibility:off&style=feature:administrative.province|element:geometry.fill|visibility:off&style=feature:administrative.province|element:geometry.stroke|visibility:off&style=feature:road|element:all|invert_lightness:true&style=feature:road|element:geometry.stroke|visibility:off&style=feature:road.arterial|element:geometry.fill|weight:1.00|visibility:off&style=feature:road.arterial|element:geometry.stroke|weight:0.51|visibility:on|hue:0xff0056&style=feature:road.local|element:geometry.fill|weight:0.90`;

    window.map1 = map1Styles;
    window.map2 = map2Styles;
    window.map3 = map3Styles;
    window.map4 = map4Styles;
    window.map5 = map5Styles;
    window.map6 = map6Styles;
    window.map7 = map7Styles;
    window.map8 = map8Styles;
    window.map9 = map9Styles;
    window.map10 = map10Styles;
  },

  placeInputAutocomplete: function () {
    $(document).ready(() => {
      let autocomplete;
      const location = '.product-right-section__local';
        const script = document.createElement('script');
        const apiKey = 'AIzaSyAF_3CAyAVqhWgtL0aqQEGmVs7X1_ycX6U';
        if (!window.scriptLoaded) {

            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initAutoComplete&libraries=places`;
            script.async = true;
            window.scriptLoaded = true;
        }

      window.initAutoComplete = function () {
        autocomplete = new google.maps.places.Autocomplete(
          document.querySelector(location), {
                types: ['establishment', 'geocode']
          }
        )
        autocomplete.addListener('place_changed', onPlaceChanged);
        
      }

      function onPlaceChanged() {
        const place = autocomplete.getPlace();
        console.log(place)

        window.local = place.name.slice(0, 25);

        if (place.address_components[3]) {
          window.complement = place.address_components[3].long_name
        } else if (place.address_components[2]) {
          window.complement = place.address_components[2].long_name
        } else if (place.address_components[1]) {
          window.complement = place.address_components[1].long_name
        } else {
          window.complement = ''
        }

        if(place) {
          if (!place.geometry) {
            document.querySelector(location).placeholder = 'Procure o local'
          } 
        } else {
          document.querySelector(location).innerHTML = place.name;
        }

        setTimeout(() => {
            document.querySelector(".product-right-section__search-icon").click();
        }, 100)

        setTimeout(() => {
            document.querySelector(".pin-selected").click();
        }, 500)
      }

      document.head.appendChild(script);

    })
  },

    getDataToMountClientMap: function () {
        let latlng;
        let mapColor;
        // const axios = require('axios');
        const apiKey = 'AIzaSyAF_3CAyAVqhWgtL0aqQEGmVs7X1_ycX6U';
        const url = 'https://maps.googleapis.com/maps/api/geocode/json';
        const location = document.querySelector(".product-right-section__local");
        const locationButton = document.querySelector(".product-right-section__search-icon");

        locationButton.addEventListener("click", function () {
            mapColor = document.querySelector(".map-color-selected").dataset.mapColor
            axios.get(url, {
                params: {
                    address: location.value,
                    key: apiKey
                }
            }).then(response => {
              console.log('updating');
              console.log(response);
                latlng = response.data.results[0].geometry.location
                console.log(latlng)
                window.latlng = `${latlng['lat']},${latlng['lng']}`
                ProductUniqueMaps.mountClientMap()
            })
        })
    },

  mountClientMap: function () {
    const localData = window.local;
    const complementData = window.complement;
    const mapColor = document.querySelector(".map-color-selected").dataset.mapColor
    const localFullText = document.querySelector(".product-right-section__local").value || 'Curitiba';
    const localText = document.querySelector(".product-left__text-local");
    const complementText = document.querySelector(".product-left__text-complement");
    const localInput = document.querySelector(".product-right-section__local-message");
    const complementInput = document.querySelector(".product-right-section__complement-message");
    const pinSelected = document.querySelector(".pin-selected").dataset.pin
    const pinColorSelected = document.querySelector(".pin-color-selected").dataset.pinColor
    const mapElement = document.getElementById("map");
    const mapOptions = {
      zoom: window.zoom || 14,
      styles: '',
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false
    }

    localInput.value = localData
    complementInput.value = complementData

    localText.textContent = localData
    complementText.textContent = complementData

    var e = jQuery.Event("keydown");
    e.which = 13;
    e.keyCode = 13
    $(localText).trigger(e);

    // $(localText).trigger()
    
    switch (mapColor) {
      case 'map1':
        mapOptions.styles = window.map1
        break;
      case 'map2':
        mapOptions.styles = window.map2
        break;
      case 'map3':
        mapOptions.styles = window.map3
        break;
      case 'map4':
        mapOptions.styles = window.map4
        break;
      case 'map5':
        mapOptions.styles = window.map5
        break;
      case 'map6':
        mapOptions.styles = window.map6
        break;
      case 'map7':
        mapOptions.styles = window.map7
        break;
      case 'map8':
        mapOptions.styles = window.map8
        break;
      case 'map9':
        mapOptions.styles = window.map9
        break;
      case 'map10':
        mapOptions.styles = window.map10
        break;
      default:
        mapOptions.styles = window.map1
        break;
    }


    console.log(window.latlng);
    window.mapImageUrl = `http://maps.googleapis.com/maps/api/staticmap?sensor=false&scale=2&size=1280x1280&zoom=${mapOptions.zoom}&center=${window.latlng}&key=AIzaSyAF_3CAyAVqhWgtL0aqQEGmVs7X1_ycX6U${mapOptions.styles}`;
    document.querySelector('#map').innerHTML = `<img src="${mapImageUrl}" />`
    if(pinSelected === "no-pin") return;

    const image =`https://cdn.shopify.com/s/files/1/0629/6200/8308/t/4/assets/${pinSelected}${pinColorSelected != 'black' ? '-' + pinColorSelected : ''}.png`;

  },

  changeMapColors: function () {
    const mapColors = document.querySelectorAll(".product-right-design__map-color");

    for (const mapColorsHandle of mapColors) {
      mapColorsHandle.addEventListener("click", function () {
          ProductUniqueMaps.mountClientMap();
      })
    }
  },

  addPinToMap: function(){
    const pins = document.querySelectorAll(".product-right-section__pin-div");

    for(const pinsHandle of pins){
      pinsHandle.addEventListener("click", function(){
          ProductUniqueMaps.updatePin();
      })
    }
  },

  updateTextButton: function () {
    const lastTabActive = document.querySelector('.product-right-header__button:last-of-type').classList.contains('button-active');
    const nextButton = document.querySelector('.product-right__button-next');
    const submitButton = document.querySelector('.product-form__cart-submit');

    if (lastTabActive) {
      nextButton.innerText = 'Finalizar';
      nextButton.style.display = 'none';
      submitButton.style.display = 'block';
    } else {
      nextButton.innerText = 'Próximo';
      nextButton.style.display = 'block';
      submitButton.style.display = 'none';
    }

  },

  updateClassFocus: function() {
    const tabIndexElements = document.querySelectorAll('[tabindex]');
    tabIndexElements.forEach(item => {
      item.addEventListener('focus', () => {
        document.querySelector('.-focus')?.classList.remove('-focus');
        item.classList.add('-focus');
      })
    })
  },

  changePinColor: function(){
    const pinColors = document.querySelectorAll(".product-right-section__pin-color");

    for(const pinColorsHandle of pinColors){
      pinColorsHandle.addEventListener("click", function(){
          ProductUniqueMaps.updatePin();
      })
    }
  },

  removeUnlessCharacters: function (item) {
    console.log(item.value)


    const regex = "1%234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNMáÁãÃàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓõÕòÒôÔöÖúÚùÙûÛüÜçÇ,~˜°.!?;:'“‘ \"$-+{}[]()_=@#^&<>/\n\r";
    let { value } = item;
    let newVal = value;

    for (var i = 0; i < value.length; i++) {
      if (!regex.includes(value.charAt(i))) {
        while (newVal.split(value.charAt(i)).length - 1 >= 1) {
          newVal = newVal.replace(value.charAt(i), "");
          item.parentNode.dataset.invalid = `${value.charAt(i)} é um caracter inválido`;
        }
        item.parentNode.classList.add("error-input");
      }
    }

    item.value = newVal;
  },

  updateInputValue: function () {
    const inputElements = document.querySelectorAll('.product-right input');
    const textAreaElements = document.querySelectorAll('.product-right textarea');
    inputElements.forEach(item => {
      console.log(item)

      item.addEventListener('keyup', function () {
        ProductUniqueMaps.removeUnlessCharacters(item);
      })

      item.addEventListener('blur', function () {
        ProductUniqueMaps.removeUnlessCharacters(item);
      })
    })
    textAreaElements.forEach(item => {
      console.log(item)

      item.addEventListener('keyup', function () {
        ProductUniqueMaps.removeUnlessCharacters(item);
      })

      item.addEventListener('blur', function () {
        ProductUniqueMaps.removeUnlessCharacters(item);
      })
    })
  },


  hideBuyButtonOnFocus: function () {
    const mqMax = window.matchMedia("(max-width: 1023px)").matches;
    const inputElements = document.querySelectorAll('.product-right input');
    const textareaElements = document.querySelectorAll('.product-right textarea');
    const buyButton = document.querySelector('.product-right__button');
    if (!mqMax) return;
    inputElements.forEach(item => {
      item.addEventListener('focus', () => {
        buyButton.classList.add('hidden');
      })
      item.addEventListener('blur', () => {
        buyButton.classList.remove('hidden');
      })
    })
    textareaElements.forEach(item => {
      item.addEventListener('focus', () => {
        buyButton.classList.add('hidden');
      })
      item.addEventListener('blur', () => {
        buyButton.classList.remove('hidden');
      })
    })
  },

  updatePin: function() {
      const pinSelected = document.querySelector(".pin-selected").dataset.pin
      const pinColorSelected = document.querySelector(".pin-color-selected").dataset.pinColor

      if (pinSelected === "no-pin") {
          document.documentElement.style.setProperty("--pin-image", '');
      } else {
          document.documentElement.style.setProperty("--pin-image", `url('${pinSelected}${pinColorSelected != 'black' ? '-' + pinColorSelected : '-black'}.png')`);
      }
  }

}

export default ProductUniqueMaps;